import { jsxs as e, jsx as s } from "../../_virtual/jsx-runtime.mjs";
import * as o from "react";
import { w as m } from "../../packages/utils/dist/useIntersectionObserver-1ee6520e.mjs";
import { reoButtonLoadingLongBar as B, reoButtonLoadingShortBar as i, animation as h } from "./LoadingBar2.mjs";
import r from "../../depend/classnames/index.mjs";
const g = (a) => {
  const t = o.useMemo(
    () => ({
      "--long-bar-width": a.longBarWidth,
      "--short-bar-width": a.shortBarWidth,
      "--long-bar-color": a.longBarColor,
      "--short-bar-color": a.shortBarColor,
      ...a.longBarStyle
    }),
    [a.longBarColor, a.longBarStyle, a.longBarWidth, a.shortBarColor, a.shortBarWidth]
  ), l = o.useMemo(
    () => r(B, a.longBarClassName),
    [a.longBarClassName]
  ), n = o.useMemo(
    () => r(i, a.shortBarClassName),
    [a.shortBarClassName]
  );
  return /* @__PURE__ */ e(
    "div",
    {
      style: t,
      className: r(
        l,
        a.animation === !1 ? null : h
      ),
      children: [
        /* @__PURE__ */ s(
          "div",
          {
            style: a.shortBarStyle,
            className: n
          }
        ),
        a.children
      ]
    }
  );
}, u = m(g, {});
export {
  u as default
};
//# sourceMappingURL=LoadingBar.mjs.map
